import React from "react";

import { SPEC_FLAGS_MAP } from "../../../../Common/constants/SpecFlagConstants";
import { useAccessStatus } from "../../../../grace-period/hooks/useAccessStatus";
import { getVisibleSpecFlag } from "../../../../grace-period/utils";

export default function PinSimpleToolTip(props) {
  const {
    pin,
    index0,
    position,
  } = props;

  const { areResultsLocked } = useAccessStatus();
  const {
    color, box_shadow_color, border_color,
  } = SPEC_FLAGS_MAP[getVisibleSpecFlag(pin.specs_flag, areResultsLocked)] ?? SPEC_FLAGS_MAP.invalid;

  return (
    <div
      className="pin-simple-tooltip"
      style={{
        border: `0.5px solid ${border_color}`,
        boxShadow: `0px 16px 8px ${box_shadow_color}`,
        bottom: `${position.bottom + 14}px`,
        left: `${position.left}px`,
        color,
        // width: `${width}px`,
      }}
    >
      {pin[index0]}
    </div>
  );
}
